import type { IUADashboardConfig, IUADashboardData } from '~/types/user-acquisition'

import config from '~/config'
import { request } from '~/utils/request'

export interface IUADashboardPayload {
  aggregations: string[]
  filters: { key: string; value?: string; values?: string[] }[]
  top_countries_count?: number
}

export const getUADashboardData = (payload: IUADashboardPayload): Promise<IUADashboardData> => {
  return request({
    data: payload,
    method: 'POST',
    url: `${config.BUSINESS_INTELLIGENCE_API}/ua-dashboard/data`,
  })
}

export const getUADashboardConfig = (): Promise<IUADashboardConfig> => {
  return request({
    url: `${config.BUSINESS_INTELLIGENCE_API}/ua-dashboard/config`,
  })
}
